import * as accountRepository from '@/supabase/deposit/repository/depositAccountRepository';
import * as onboardingRepository from '@/supabase/deposit/repository/onboardingRepository';

// 같은 탭 계좌 변경 이벤트명 — 훅(useDepositActionCount)은 service만 import하는 규율이라 재노출.
export { DEPOSIT_ACCOUNT_CHANGED_EVENT } from '@/supabase/deposit/repository/depositAccountRepository';

export type DepositAccountConnectionStatus = 'unlinked' | 'in_progress' | 'linked';

export async function getDepositAccountConnectionStatus(): Promise<DepositAccountConnectionStatus> {
  const accounts = await accountRepository.listAccounts();
  if (accounts.length === 0) return 'unlinked';

  // 정규 링크 술어(스펙 §16.6)와 정렬: is_active AND (verification 없음 OR legacy/confirmed).
  // 서버 has_active_linked_deposit_account와 동일 규칙 — 비활성(연동 해제) 계좌를 linked로
  // 오판해 자동 전환이 안 도는데 액션 UI만 노출되는 불일치 제거.
  // 검증 상태 조회 실패는 throw로 전파(fail-closed) — 'linked' 폴백은 Home 부분입금 상태 옵션
  // (직접 CRUD 경로) 게이트를 오개방했다. 호출측이 각자 처리: useDepositAccountStatus → 'unknown'
  // (CTA 미노출 + 계좌관리 노출 = 기존 CTA 방어 유지, 액션 게이트는 fail-closed),
  // DepositLaunchModal → 자체 catch fail-open(1회 노출, 무해).
  const verifications = await onboardingRepository.listAccountVerifications();
  const hasLinkedAccount = accounts.some((account) => {
    if (!account.is_active) return false;
    const status = verifications[account.id];
    return status === undefined || status === 'legacy' || status === 'confirmed';
  });
  return hasLinkedAccount ? 'linked' : 'in_progress';
}
